// import { Link } from 'react-router-dom';

// import { PATHS } from '@/constants/page-paths';
import { useAuth } from '@/lib/hooks/useAuth';
import { ProfileDropdown } from '../../ProfileDropdown';
// import { MobileMenu } from './MobileMenu';
import { Logout } from '@/components/shared/Logout';
import { Power } from 'lucide-react';

export const RightNav = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="flex items-center justify-between gap-2 lg:gap-4 h-full">
      {isAuthenticated ? (
        <>
          <ProfileDropdown />
          <Logout>
            <span className='w-8 h-8 bg-muted border flex items-center justify-center rounded-full hover:bg-secondary/80 transition p-2'>
              <Power className='cursor-pointer'/>
            </span>
          </Logout>
          {/* <MobileMenu /> */}
        </>
      ) : (
        <div
          className="flex items-center gap-2 md:gap-4"
          data-testid="sign-in-right-nav"
        >
          {/* <Link to={PATHS.SIGN_IN}>Sign-in</Link> */}
          {/* <MobileMenu /> */}
        </div>
      )}
    </div>
  );
};
